import { render, staticRenderFns } from "./Luo2.vue?vue&type=template&id=4ff50906&"
import script from "./Luo2.vue?vue&type=script&lang=js&"
export * from "./Luo2.vue?vue&type=script&lang=js&"
import style0 from "./Luo2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports